import { render, staticRenderFns } from "./scenario-compare-details-table.vue?vue&type=template&id=620dc9cc&scoped=true"
import script from "./scenario-compare-details-table.vue?vue&type=script&lang=ts"
export * from "./scenario-compare-details-table.vue?vue&type=script&lang=ts"
import style0 from "./scenario-compare-details-table.vue?vue&type=style&index=0&id=620dc9cc&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620dc9cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('620dc9cc')) {
      api.createRecord('620dc9cc', component.options)
    } else {
      api.reload('620dc9cc', component.options)
    }
    module.hot.accept("./scenario-compare-details-table.vue?vue&type=template&id=620dc9cc&scoped=true", function () {
      api.rerender('620dc9cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/results/scenario-compare/lightbox/scenario-compare-details-table.vue"
export default component.exports